import { alpha, type Theme } from '@mui/material/styles';
import {
  getExportRowHighlightOption,
  type ExportRowHighlightColor,
} from '../lib/rowHighlights';

export function getExportRowHighlightSx(input: {
  color: ExportRowHighlightColor | undefined;
  selectedRow: boolean;
  theme: Theme;
}) {
  const option = getExportRowHighlightOption(input.color);
  if (!option) {
    return {};
  }

  const backgroundAlpha = input.selectedRow
    ? input.theme.palette.mode === 'light' ? 0.22 : 0.3
    : input.theme.palette.mode === 'light' ? 0.16 : 0.24;
  const hoverAlpha = input.selectedRow
    ? input.theme.palette.mode === 'light' ? 0.3 : 0.38
    : input.theme.palette.mode === 'light' ? 0.24 : 0.32;

  return {
    backgroundColor: alpha(option.main, backgroundAlpha),
    boxShadow: `inset 4px 0 0 ${option.main}`,
    '&:hover': {
      backgroundColor: alpha(option.main, hoverAlpha),
    },
    '& > td:first-of-type': {
      boxShadow: `inset 4px 0 0 ${option.main}`,
    },
  };
}
